import { Checkbox, FormControlLabel, Grid, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./CookieBar.styles";
import * as React from "react";
import { useState } from "react";
import { withStyles } from "@material-ui/styles";
import { BlueButton } from "../Buttons/BlueButton";
import { isCookieConsent, setCookieConsent, getCookieConsent } from "./CookieHelper";
import { useHistory, useLocation } from "react-router-dom";
import { BlueLink } from "../Links/BlueLink";

export interface ICookieBarProps extends WithStyles<typeof styles> {}

const CookieBarPure: React.FunctionComponent<ICookieBarProps> = ({ classes }: ICookieBarProps) => {
    const [open, setOpen] = useState(!isCookieConsent());
    const [detailsOpen, setDetailsOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const saveAndClose = value => {
        setCookieConsent(value);
        setOpen(false);

        if (location.pathname === "/") {
            history.go(0);
        }
    };

    return open ? (
        <div className={classes.banner}>
            <Grid container spacing={2} className={classes.content}>
                <Grid item sm={9}>
                    <Typography variant="body1" className={classes.text}>
                        Welcome to Deutsche Börse AG Data Shop! If you give us your consent and click "Accept all", we use cookies and similar technologies on our website to give you the best possible online experience. Please note that based on your settings, not all functions of the website may be available. For more information and how to withdraw your consent, see our{" "}
                        <BlueLink inline to="/privacy-notice" variant="body1">
                            privacy policy
                        </BlueLink>
                        .
                    </Typography>
                    <FormControlLabel
                        className={classes.checkbox}
                        control={<Checkbox checked={true} disabled={true} />}
                        label={
                            <Typography variant="h4" onClick={() => setDetailsOpen(!detailsOpen)}>
                                Only use necessary technologies
                            </Typography>
                        }
                    />
                    <FormControlLabel
                        className={classes.checkbox}
                        control={<Checkbox checked={getCookieConsent() === "all"} disabled={true}/>}
                        label={
                            <Typography variant="h4" onClick={() => setDetailsOpen(!detailsOpen)}>
                                Use functional technologies
                            </Typography>
                        }
                    />
                    {detailsOpen ? (
                        <Typography variant="body2" className={classes.text}>
                            Necessary cookies enable core functionality such as security, network management, and
                            accessibility. You may disable these by changing your browser settings, but this may affect
                            how the website functions.
                        </Typography>
                    ) : null }
                </Grid>
                <Grid item sm={2}>
                    <Grid container className={classes.buttons} direction="column">
                        <Grid item>
                            <BlueButton fullWidth onClick={() => saveAndClose("all")}>Accept all</BlueButton>
                        </Grid>
                        <Grid item>
                            <BlueButton fullWidth onClick={() => saveAndClose("necessary")}>Only use necessary technologies</BlueButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
        ) : (
            <div className={classes.minimized} onClick={() => setOpen(true)}>
                <Typography>Cookie manager</Typography>
            </div>
        );
};

export const CookieBar = withStyles(styles)(CookieBarPure);